import React, { FC, useEffect } from 'react';
import { Breadcrumbs, PageHeader } from '@plataforma-xvia/design-system-es';
import { FooterContainer } from '../modules/footer/footer.container';
import { ListContainer } from '../modules/list/list.container';
import { ROUTES } from '../routes';
import { buildAppPath } from '../utils/basePath';

export const ServiceList: FC = () => {
  useEffect(() => {
    if (typeof window !== 'undefined' && window.scrollY !== 0) {
      window.scrollTo(0, 0);
    }
  }, []);

  return (
    <>
      <PageHeader
        title="Serviços Disponíveis"
        breadcrumb={
          <Breadcrumbs
            tone="inverted"
            showBackButton
            items={[
              { name: 'Início', path: buildAppPath('/') },
              {
                name: 'Serviços Disponíveis',
                path: buildAppPath(ROUTES.SERVICE_LIST_PAGE),
              },
            ]}
          />
        }
      />
      <ListContainer />
      <FooterContainer />
    </>
  );
};
